import { pageTitles } from '@shared/enums/pageTitles';
import { useTitle } from '@shared/hooks/useTitle';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AsyncData } from '@shared/interfaces/asyncData';
import { LocationOptionData } from '@shared/interfaces/LocationOptionData';
import { MyTeamEvalData } from '@modules/EvaluationModule/interfaces/MyTeamEvalData';
import { getAllLocationsData, getMyPeopleEvalData, setMyPeopleEvalDataLoading } from '../redux/actions';
import { selectLocations, selectMyPeopleEvalData } from '../redux/selectors';
import { sortLocationOptions } from '@shared/helpers/sortLocationOptions';
import { DEFAULT_PAGINATION_DATA } from '../constants/pagination';

export const useMyPeopleEvalData = (): {
  myPeopleEvalData: AsyncData<MyTeamEvalData[]>;
  locationOptions: LocationOptionData[];
} => {
  const dispatch = useDispatch();
  const myPeopleEvalData = useSelector(selectMyPeopleEvalData);
  const locationsData = useSelector(selectLocations) ?? [];
  const [locationOptions, setLocationOptions] = useState<LocationOptionData[]>(locationsData);
  const setPageTitle = useTitle();

  useEffect(() => {
    setPageTitle(pageTitles.myPeopleEvalPage);
  }, []);

  useEffect(() => {
    dispatch(getAllLocationsData());
  }, []);

  useEffect(() => {
    dispatch(getMyPeopleEvalData(DEFAULT_PAGINATION_DATA));

    return () => {
      dispatch(setMyPeopleEvalDataLoading());
    };
  }, []);

  useEffect(() => {
    if (locationsData.length > 0) {
      setLocationOptions(sortLocationOptions(locationsData));
    }
  }, [locationsData]);

  return { myPeopleEvalData, locationOptions };
};
